import { useLocalstorageState } from 'rooks';

const Loader = () => {
  const [isDarkMode] = useLocalstorageState(`dark-mode`, true);

  const fill = isDarkMode ? 'var(--primary-white)' : 'var(--primary-midnight)';

  return (
    <div className="flex justify-center items-center h-full">
      <svg
        width="70"
        height="70"
        viewBox="0 0 522 686"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="animate-bounce"
      >
        <path
          d="M0 0H385.121V80.2336H80.2336V509.486L0 429.253V0Z"
          fill={fill}
        />
        <path
          d="M176.514 605.766L256.747 686V469.366H409.191V389.133H176.514V605.766Z"
          fill={fill}
        />
        <path
          d="M385.121 272.794H184.537V192.561H385.121V272.794Z"
          fill={fill}
        />
        <path
          d="M385.124 80.2336C416.143 80.2336 441.288 105.379 441.288 136.397C441.288 167.415 416.143 192.561 385.124 192.561V272.794C460.454 272.794 521.521 211.727 521.521 136.397C521.521 61.067 460.454 0 385.124 0V80.2336Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};

export default Loader;
